// Generates the recurring bookings for a group plan: one booking per occurrence
// of `dayOfWeek` between `fromDate` and `toDate`, at the given start/stop time.
//
// Extracted from GroupScheduler so the recurrence logic can be unit-tested in
// isolation (no Ionic / React imports). Behaviour is intentionally identical to
// the previous in-component implementation.
export function doPlanification(
  userId,
  fromDate,
  toDate,
  timeStart,
  timeStop,
  dayOfWeek,
  selectedAthletes,
  club,
  field,
  groupId,
  maxParticipants,
  tags,
  label,
  description,
  clubName,
  fieldName,
) {
  // save a new event in the calendar from fromDate to toDate using selectedAthletes every dayOfWeek at timeStart to timeStop
  let currentDate = new Date(fromDate);
  let endDate = new Date(toDate);

  // remove time from dates
  currentDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  const dateTimeStart = new Date(timeStart);
  const dateTimeStop = new Date(timeStop);

  const bookings = [];
  const remainingSlots = maxParticipants - selectedAthletes.length;

  while (currentDate <= endDate) {
    if (currentDate.getDay() === dayOfWeek) {
      const booking = {
        club,
        field,
        participantUserIds: selectedAthletes
          .filter((a) => a.userId)
          .map((a) => a.userId),
        participants: selectedAthletes,
        from: new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          new Date(dateTimeStart).getHours(),
          new Date(dateTimeStart).getMinutes(),
        ),
        to: new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          new Date(dateTimeStop).getHours(),
          new Date(dateTimeStop).getMinutes(),
        ),
        relatedGroupId: groupId,
        relatedSupervisorId: userId,
        maxParticipants,
        remainingSlots,
        tags: tags.map((t) => t.id),
        label,
        description,
        clubName,
        fieldName,
      };
      bookings.push(booking);
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return bookings;
}

export default doPlanification;
